import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CellEditorStoreService } from '../../cell-editor-store.service';

@Component({
  selector: 'kve-content-width-slider',
  templateUrl: './content-width-slider.component.html',
  styleUrls: ['./content-width-slider.component.scss']
})
export class ContentWidthSliderComponent implements OnInit {
  title: string;
  currentValue: number;
  optionsSet = false;

  @Output() selectedWidth: EventEmitter<number> = new EventEmitter<number>();
  options: Options = {
    floor: 50,
    ceil: 100,
    step: 10,
    showTicks: true,
  };

  constructor(private cellEditorStoreService: CellEditorStoreService) { }

  ngOnInit(): void {
  }

  onUserChangeStart(e) { }
  onUserChange(e) { }
  onUserChangeEnd(changeContext: ChangeContext) {
    console.log(changeContext.value);
    this.selectedWidth.emit(changeContext.value);
    this.cellEditorStoreService.selectedCell$.subscribe(selectedCell => {
      selectedCell.contentWidth = changeContext.value + "%";
      console.log("cell-editor-store.service.ts - updating selected cell contentWidth: " + selectedCell);
      this.cellEditorStoreService.updateSelectedCell(selectedCell);
    })
  }
}
